module.exports = __webpack_public_path__ + "img/logo-paycomet-bsabadell-grey.5010c112.svg";